import React from 'react';
import { Dialog, DialogContent, Box, Typography, Button, IconButton } from '@mui/material';
import { X } from 'lucide-react';

interface PopupPreviewProps {
  title: string;
  body: string;
  cta?: string;
  onClose: () => void;
}

export const PopupPreview: React.FC<PopupPreviewProps> = ({
  title,
  body,
  cta = 'OK',
  onClose,
}) => {
  return (
    <Dialog
      open={true}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: '24px',
          p: 2,
        },
      }}
    >
      <DialogContent sx={{ p: 0 }}>
        <Box
          sx={{
            textAlign: 'center',
            p: 4,
          }}
        >
          {/* Close button */}
          <IconButton
            onClick={onClose}
            sx={{
              position: 'absolute',
              right: 16,
              top: 16,
            }}
          >
            <X size={20} />
          </IconButton>

          {/* Preview Label */}
          <Box
            sx={{
              display: 'inline-block',
              px: 2,
              py: 0.5,
              bgcolor: '#FEF3C7',
              color: '#F59E0B',
              borderRadius: '12px',
              fontSize: '0.75rem',
              fontWeight: 700,
              textTransform: 'uppercase',
              letterSpacing: '0.1em',
              mb: 3,
            }}
          >
            Preview - How it appears
          </Box>

          {/* Mock notification UI */}
          <Box
            sx={{
              bgcolor: '#6366F1',
              borderRadius: '20px',
              p: 4,
              color: 'white',
              textAlign: 'left',
              position: 'relative',
              overflow: 'hidden',
            }}
          >
            {/* Background emoji */}
            <Box
              sx={{
                position: 'absolute',
                right: -20,
                bottom: -20,
                fontSize: '8rem',
                opacity: 0.1,
                pointerEvents: 'none',
              }}
            >
              📢
            </Box>

            {/* Content */}
            <Box sx={{ position: 'relative', zIndex: 1 }}>
              <Box
                sx={{
                  display: 'inline-block',
                  px: 1.5,
                  py: 0.5,
                  bgcolor: 'rgba(255,255,255,0.2)',
                  borderRadius: '8px',
                  fontSize: '0.625rem',
                  fontWeight: 700,
                  textTransform: 'uppercase',
                  letterSpacing: '0.1em',
                  mb: 2,
                }}
              >
                School Notification
              </Box>

              <Typography
                variant="h5"
                sx={{
                  fontWeight: 900,
                  mb: 2,
                  lineHeight: 1.2,
                }}
              >
                {title}
              </Typography>

              <Typography
                sx={{
                  fontSize: '1rem',
                  lineHeight: 1.6,
                  opacity: 0.95,
                  mb: 3,
                }}
              >
                {body}
              </Typography>

              <Button
                variant="contained"
                fullWidth
                sx={{
                  bgcolor: 'white',
                  color: '#6366F1',
                  fontWeight: 700,
                  py: 1.5,
                  borderRadius: '12px',
                  textTransform: 'none',
                  fontSize: '1rem',
                  '&:hover': {
                    bgcolor: '#F9FAFB',
                  },
                }}
              >
                {cta}
              </Button>
            </Box>
          </Box>

          {/* Helper text */}
          <Typography
            sx={{
              fontSize: '0.875rem',
              color: '#6B7280',
              mt: 3,
            }}
          >
            This is how the notification will appear to recipients
          </Typography>
        </Box>
      </DialogContent>
    </Dialog>
  );
};
